import { flow, types, getEnv, getSnapshot } from 'mobx-state-tree'

import { AdminAthleteModel } from '.'

const AdminAthletes = types
  .model('AdminAthletesModel', {
    content: types.optional(types.array(AdminAthleteModel), []),
    page: types.optional(types.number, 0),
    size: types.optional(types.number, 0),
    totalPages: types.optional(types.number, 1),
    sportType: types.optional(types.string, ''),
    name: types.optional(types.string, ''),
  })
  .actions((self) => {
    const {
      services: { adminAthletesService },
    } = getEnv(self)

    const loadAthletesGlobal = function* ({ name, sportType, page, size }) {
      const response = yield adminAthletesService.queryAthletes({
        name,
        sportType,
        page,
        size,
      })

      self.content = response.content
      self.totalPages = response.totalPages
      self.page = response.pageable.pageNumber
      self.size = response.pageable.pageSize
      self.name = name || ''
      self.sportType = sportType || ''

      return getSnapshot(self)
    }

    const athleteAdded = () => {
      self.page = self.totalPages - 1
    }

    return {
      loadAthletes: flow(({ name, sportType, page, size }) =>
        loadAthletesGlobal({
          name,
          sportType,
          page,
          size,
        })
      ),
      onAthleteAdded: athleteAdded,
    }
  })

export const AdminAthletesRoot = types.model('AdminAthletes', {
  adminAthletes: types.optional(AdminAthletes, {}),
})
